import React from 'react';

var ListViewContentLeft = React.createClass({
  getInitialState: function(){
    return { act : "" };
  },
  makeActive: function(slug){
    this.props.makeActive(slug);
  },
  popup: function(value){
    this.props.popup(value);
    this.setState({act: value});
  },
  isClicked: function(){
    this.props.isClicked();
  },
  render: function(){
    var contentLeft = this.props.value;
         /* rating star logic */
        var ratings = [];
        var ratingAvg  = contentLeft["rating_avg"];
        for(var i=1;i<=5;i++)
        {
          var decimal = Math.floor(ratingAvg);
          var fraction = ratingAvg % 1;
          var ratingClas;
          if(i<= decimal){
            ratingClas = "fa fa-star";  // for empty star.
          }
          else if(fraction >= 0.5 && i<= decimal+1){
            ratingClas = "fa fa-star-half-o";  // for half filled star.
          }
          else{
            ratingClas = "fa fa-star-o";  // for full filled star.
          }
          ratings.push(<i key = {i} className = {ratingClas}/>);
        }  

    var flag = ( (this.state.act == contentLeft["name"].split("/")[1]) || (this.state.act == contentLeft["name"]) );
    return(
          <div className="theme-list__desc">
              <div className="theme-list__desc--inner">
                <h4>{contentLeft["name"].split("/")[1]}</h4>
                <p>by {contentLeft["name"].split("/")[0]}</p>
                <p>
                  <strong>
                    <span>Rating:</span>
                    <span className="rating--star">{ratings}</span> 
                    <span>({contentLeft["rating_count"]})</span>
                  </strong>
                </p>
              </div>
              { this.props.showButton ?
                <div>
                    { this.props.active ==  contentLeft["name"] ?
                      <ListViewActiveButton value =  {this.props.value}/> :
                      
                        <ListViewActivateButton value = {this.props.value}
                                                makeActive = {this.makeActive}
                                                popup = {this.popup} /> 
                    }
                  
                </div> : <div /> }
          </div>
    );
  }
});
var ListViewActivateButton = React.createClass({
  getInitialState : function () {
    return {
      "isClicked" :  false
    };
  },
  handleClick: function(){
     this.setState ({isClicked : true})
    // if (this.props.value.user !== localStorage.getItem ('currentAccountSlug')) {
       var fullyQualifiedName =  this.props.value["name"];
       this.props.makeActive(fullyQualifiedName);
     // } else {
       // this.props.makeActive(this.props.value["slug"]);
     // }
  },
  render: function(){
    var classes = "animate__btn";
    if (this.state.isClicked) {
      classes += "  clicked"
    };
    return(
          <a href = "javascript:void(0)" className= {classes} onClick = {this.handleClick}>
            <span className="btn_1 ">
               <i className="fa fa-spinner fa-spin"></i> Waiting
            </span>
            <span className="btn_2"><strong className="icon"><i className="fa fa-arrow-circle-up"></i> <i className="fa  fa-check-circle"></i></strong> Activate</span>
            <span className="btn_3"><i className="fa  fa-check-circle"></i> Active</span>
            Activate
          </a>
      );
  }
});

//"btn__lg bg-dark"
var ListViewActiveButton = React.createClass({
  getInitialState: function(){
    return { 
      isClicked: true 
    };
  },
  handleClick: function(){
    alert(this.props.value["name"].split("/")[1] + " is already active");
  },
  render: function(){
    var classes = "animate__btn";
    if (this.state.isClicked) {
      classes += "  success"
    }
    return(
      <a href = "javascript:void(0)" className= {classes} onClick = {this.handleClick}>
        <span className="btn_1 ">
           <i className="fa fa-spinner fa-spin"></i> Waiting
        </span>
        <span className="btn_2"><strong className="icon"><i className="fa fa-arrow-circle-up"></i> <i className="fa  fa-check-circle"></i></strong> Activate</span>
        <span className="btn_3"><i className="fa  fa-check-circle"></i> Active</span>
        Activate
      </a>
      );
  }
});

export {ListViewContentLeft};


/** WEBPACK FOOTER **
 ** ./html/components/ListViewContentLeft.jsx
 **/